module.exports = __webpack_public_path__ + "img/Splunk-Corp-Logo-K-rgb.a2870090.png";